import { makeStyles } from '@material-ui/core';

export const useStyles = makeStyles(() => ({
  bodyFooter: {
    borderTop: 'dashed 1px #2C2D3E4D',
    '& > *': {
      marginTop: '15px',
    },
  },
}));
